import * as yup from 'yup';

export const addColumnSchemas = yup
  .object()
  .shape({
    columnName: yup.string().required('Column Name is required.'),
  })
  .required();
